import React from 'react';
import PropTypes from 'prop-types';

import Hoverable from 'common/components/Hoverable';

import LayoutNodeContentContainer from './LayoutNodeContentContainer';
import LayoutNodeLabel from './LayoutNodeLabel';
import { FormBuilderContext } from '../FormBuilder/FormBuilder';

export function FormEditorRow(props) {
    return (
        <Hoverable>
            {(isHovered, onMouseEnter, onMouseLeave) => (
                <LayoutNodeContentContainer
                    depth={0}
                    isActive={isHovered}
                    canEdit={!props.isDisabled}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onClick={props.isDisabled ? () => {} : props.onClick}
                >
                    <FormBuilderContext.Consumer>
                        {({ permissions: { canUserEditForm: canUserAccess } }) => (
                            <LayoutNodeLabel
                                isRequired={props.isRequired}
                                isFaded={!canUserAccess || props.isDisabled}
                                isActive={isHovered}
                                subtitle={props.subtitle}
                                onFocus={onMouseEnter}
                                onBlur={onMouseLeave}
                                onClick={props.isDisabled ? () => {} : props.onClick}
                                disabled={!canUserAccess || props.isDisabled}
                            >
                                {props.children}
                            </LayoutNodeLabel>
                        )}
                    </FormBuilderContext.Consumer>
                </LayoutNodeContentContainer>
            )}
        </Hoverable>
    );
}

FormEditorRow.propTypes = {
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    subtitle: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

FormEditorRow.defaultProps = {
    isDisabled: false,
    isRequired: false,
    subtitle: '',
    onClick: () => {},
};
